export default __webpack_public_path__ + "static/2294-3e19af41201c58358d7db4c0bf36f304.gif";